// /assets/card-product-variant.js
(function () {
  const LOG = false;
  const cache = new Map();

  // ---------- utils ----------
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts || false);
  const log = (...a) => LOG && console.log('[card-variants]', ...a);
  const logEv = (label, e) => {
    if (!LOG) return;
    const p = e.eventPhase === 1 ? 'capture' : e.eventPhase === 2 ? 'target' : 'bubble';
    console.log('[card-variants]', label, { type: e.type, phase: p, tgt: (e.target?.getAttribute?.('data-dir')) || e.target?.className || e.target?.nodeName });
  };

  // ---------- size ordering ----------
  const APPAREL_ORDER = ["XXXS","XXS","XS","S","M","L","XL","XXL","2XL","3XL","4XL","5XL","OS","ONE SIZE","ONE SIZE FITS MOST","OSFM"];
  const _norm = (s) => String(s || "").trim().toUpperCase();
  const _parseNum = (v) => { const m = String(v || "").trim().match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; };
  const _apparelRank = (v) => { const t=_norm(v).split(/[\/\-\s]+/).filter(Boolean); let best=999; for(const x of t){const i=APPAREL_ORDER.indexOf(x); if(i!==-1&&i<best) best=i;} return best; };
  const _sizeComparator = (a, b) => {
    const an=_parseNum(a), bn=_parseNum(b), aN=Number.isFinite(an), bN=Number.isFinite(bn);
    if (aN && bN) return an - bn;
    if (aN && !bN) return -1;
    if (!aN && bN) return 1;
    const ar=_apparelRank(a), br=_apparelRank(b);
    if (ar !== br) return ar - br;
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
  };
  const sortSizes = (arr) => arr.slice().sort(_sizeComparator);

  // ---------- URL + product JSON ----------
  function handleFromUrl(url) {
    try {
      const a = document.createElement('a'); a.href = url;
      const parts = a.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      return i !== -1 ? parts[i + 1] : null;
    } catch { return null; }
  }
  async function getProductJson(handle) {
    if (!handle) throw new Error('Missing handle');
    if (cache.has(handle)) return cache.get(handle);
    const p = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(j => { log('product.json', handle, j.title || ''); return j; });
    cache.set(handle, p);
    return p;
  }

  // ---------- map + index ----------
  function buildWidthSizeMap(prod) {
    const opts = (prod.options || []).map(o => (o && o.name) ? String(o.name).trim() : String(o || '').trim());
    let sizeIdx = -1, widthIdx = -1;
    opts.forEach((name, i) => {
      const d = name.toLowerCase();
      if (sizeIdx === -1 && (d.includes('size') || d.includes('us'))) sizeIdx = i;
      if (widthIdx === -1 && (d.includes('width') || d.includes('fit'))) widthIdx = i;
    });
    if (sizeIdx === -1) return { map: null, sizeIdx, widthIdx };

    const vlist = prod.variants || [];
    if (widthIdx === -1) {
      const set = new Set();
      vlist.forEach(v => { if (v.available) set.add(String([v.option1, v.option2, v.option3][sizeIdx] || '').trim()); });
      const sizes = sortSizes(Array.from(set).filter(Boolean));
      if (!sizes.length) return { map: null, sizeIdx, widthIdx };
      return { map: { __NO_WIDTH__: sizes }, sizeIdx, widthIdx };
    }

    const wMap = new Map();
    vlist.forEach(v => {
      if (!v.available) return;
      const vals = [v.option1, v.option2, v.option3];
      const w = String(vals[widthIdx] || '').trim();
      const s = String(vals[sizeIdx]  || '').trim();
      if (!w || !s) return;
      if (!wMap.has(w)) wMap.set(w, new Set());
      wMap.get(w).add(s);
    });
    if (!wMap.size) return { map: null, sizeIdx, widthIdx };

    const map = {};
    wMap.forEach((set, w) => { const sizes = sortSizes(Array.from(set)); if (sizes.length) map[w] = sizes; });
    return { map, sizeIdx, widthIdx };
  }

  function buildVariantIndex(prod, sizeIdx, widthIdx) {
    const idx = Object.create(null);
    (prod.variants || []).forEach(v => {
      const vals = [v.option1, v.option2, v.option3];
      const size  = String(vals[sizeIdx]  || '').trim();
      const width = widthIdx === -1 ? '' : String(vals[widthIdx] || '').trim();
      if (!size) return;
      const key = widthIdx === -1 ? size : `${width}||${size}`;
      if (!idx[key] || (!idx[key].available && v.available)) idx[key] = { id: v.id, available: !!v.available, price: v.price };
    });
    log('variant-index keys', Object.keys(idx).length);
    return idx;
  }

  // ---------- restrictions ----------
  function isRestrictedVendor(vendor){
    const name = String(vendor || '').trim();
    if (!name) return false;
    try {
      if (window.RESTRICTED_BRANDS_REGEX) {
        const rx = new RegExp(window.RESTRICTED_BRANDS_REGEX, 'i');
        if (rx.test(name)) return true;
      }
    } catch {}
    if (Array.isArray(window.RESTRICTED_BRANDS)) {
      return window.RESTRICTED_BRANDS.some(v => String(v).trim().toLowerCase() === name.toLowerCase());
    }
    return false;
  }

  // ---------- DOM containers ----------
  function ensureHosts(card) {
    let variants = $('.card-product__variants', card);
    if (!variants) {
      const footer  = $('.card-product__footer', card);
      variants = document.createElement('div');
      variants.className = 'card-product__variants';
      variants.setAttribute('aria-label','Available sizes by width');
      if (footer) {
        const add = $('.card-product__add', card);
        if (add) add.insertAdjacentElement('beforebegin', variants);
        else footer.appendChild(variants);
      } else {
        const price = $('.card-product__price', card);
        if (price) price.insertAdjacentElement('afterend', variants);
        else card.appendChild(variants);
      }
    }
    return { variants };
  }
  function renderNoSizes(card, note) {
    const { variants } = ensureHosts(card);
    variants.innerHTML = `<div class="card-product__sizes-empty" role="status">${note || 'No sizes available'}</div>`;
    const add = $('.card-product__add', card);
    if (add) add.remove();
  }
  const hideSizesUI = (card) => { const l=card.querySelector('.card-product__sizes-label'); if (l) l.style.display='none'; const v=card.querySelector('.card-product__variants'); if (v) v.style.display='none'; };
  const showSizesUI = (card) => { const l=card.querySelector('.card-product__sizes-label'); if (l) l.style.display='';     const v=card.querySelector('.card-product__variants'); if (v) v.style.display=''; };

  // ---------- Add-to-Bag ----------
  function ensureAddToCart(card, prod) {
    const restricted = card.getAttribute('data-brand-restricted') === 'true' || isRestrictedVendor(prod.vendor);
    log('restricted-check', { vendor: prod.vendor, restricted });
    if (restricted) { renderInStoreOnly(card); return null; }
    clearRestrictedState(card);
    let add = $('.card-product__add', card);
    if (!add) {
      add = document.createElement('div');
      add.className = 'card-product__add';
      add.innerHTML = `
        <input type="hidden" data-variant-id value="">
        <button type="button"
          class="button button--full-width button--fat button--add-to-cart card-product__add-btn"
          disabled aria-label="Add to Bag">
          <span class="button-label">Add to Bag</span>
        </button>`;
      const { variants } = ensureHosts(card);
      variants.insertAdjacentElement('afterend', add);
    }
    return add;
  }
  function updateAddToCart(card, variant, prod) {
    const root = ensureAddToCart(card, prod);
    if (!root) { log('ATC skipped (restricted)'); return; }
    const input = $('[data-variant-id]', root);
    const btn = $('.card-product__add-btn', root);
    if (variant && variant.id && variant.available) { input.value = variant.id; btn.disabled = false; log('ATC enabled', variant.id); }
    else { input.value = ''; btn.disabled = true; log('ATC disabled'); }
  }

  // ---------- hard stop helpers ----------
  function kill(e, label) { logEv(label, e); e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); }

  // ---------- slider ----------
  function initSwatchSlider(card) {
    if (card.dataset.swatchSliderInit === '1') return;
    const slider = card.querySelector('.card-product__swatch-slider');
    const track  = card.querySelector('.card-product__swatch-track');
    if (!slider || !track) return;
    card.dataset.swatchSliderInit = '1';

    const prev = slider.querySelector('[data-dir="prev"]');
    const next = slider.querySelector('[data-dir="next"]');

    // mark ONLY the nav buttons (NOT slider/track) so swatch buttons remain active
    prev && prev.setAttribute('data-nav-guard','1');
    next && next.setAttribute('data-nav-guard','1');

    // ensure buttons don't submit forms
    if (prev && prev.tagName === 'BUTTON' && !prev.hasAttribute('type')) prev.type = 'button';
    if (next && next.tagName === 'BUTTON' && !next.hasAttribute('type')) next.type = 'button';

    const pageSize = () => Math.max(track.clientWidth - 40, 80);
    const onNav = (dir) => { const dx = (dir === 'next' ? 1 : -1) * pageSize(); log('nav', dir, { dx }); track.scrollBy({ left: dx, behavior: 'smooth' }); };

    // prevent native behaviors early; do action in CAPTURE click; DO NOT touch track/swatches here
    ['pointerdown','touchstart','mousedown'].forEach((ev) => {
      prev && prev.addEventListener(ev, (e) => kill(e, `nav:${ev}:prev`), { capture: true, passive: false });
      next && next.addEventListener(ev, (e) => kill(e, `nav:${ev}:next`), { capture: true, passive: false });
    });
    prev && prev.addEventListener('click', (e) => { kill(e, 'nav:click:prev'); onNav('prev'); }, { capture: true, passive: false });
    next && next.addEventListener('click', (e) => { kill(e, 'nav:click:next'); onNav('next'); }, { capture: true, passive: false });

    // after our action, swallow nav button clicks at slider (extra safety)
    on(slider, 'click', (e) => { if (e.target.closest('[data-dir]')) { logEv('slider:stop-nav-bubble', e); e.stopPropagation(); } });

    // drag-to-scroll track (swatches continue to receive clicks)
    let isDown = false, dragged = false, startX = 0, startLeft = 0;
    const onDown = (e) => { logEv('track:down', e); isDown = true; dragged = false; startX = (e.touches ? e.touches[0].clientX : e.clientX); startLeft = track.scrollLeft; };
    const onMove = (e) => { if (!isDown) return; const x = (e.touches ? e.touches[0].clientX : e.clientX); const dx = x - startX; if (Math.abs(dx) > 3) dragged = true; track.scrollLeft = startLeft - dx; };
    const onUp   = (e) => { logEv('track:up', e); isDown = false; };
    on(track, 'mousedown', onDown, { capture: true });
    on(track, 'mousemove', onMove,  { capture: true });
    on(window,'mouseup',   onUp,    { capture: true });
    on(track, 'touchstart',onDown,  { capture: true, passive: true });
    on(track, 'touchmove', onMove,  { capture: true, passive: true });
    on(window,'touchend',  onUp,    { capture: true, passive: true });

    // only suppress when dragging OR clicking empty rail; swatch buttons click through
    on(track, 'click', (e) => {
      const isSwatchBtn = !!e.target.closest('.group-product button');
      if (dragged || !isSwatchBtn) { logEv('track:suppress-click', e); e.preventDefault(); e.stopPropagation(); }
    }, true);

    function updateNavVisibility() {
      const total = track.querySelectorAll('.group-product').length;
      const has = total >= 2;
      slider.classList.toggle('has-swatches', has);
      log('nav-visibility', { total, has });
    }
    function clampButtons() {
      const max = track.scrollWidth - track.clientWidth - 1;
      const left = track.scrollLeft <= 1;
      const right = track.scrollLeft >= max;
      if (prev) prev.disabled = left;
      if (next) next.disabled = right;
      slider.classList.toggle('is-leftmost', left);
      slider.classList.toggle('is-rightmost', right);
    }
    on(track, 'scroll', clampButtons, { passive: true });
    on(window,'resize', clampButtons);
    const ro = new ResizeObserver(() => { clampButtons(); updateNavVisibility(); });
    ro.observe(track);
    queueMicrotask(() => { clampButtons(); updateNavVisibility(); });
    on(window, 'load', () => { clampButtons(); updateNavVisibility(); });
  }

  // ---------- render sizes ----------
  function renderMap(card, map, limits, prod) {
    const { showWidthLimit = 5, showSizeLimit = 20 } = limits || {};
    const { variants } = ensureHosts(card);
    if (!map || !Object.keys(map).length) { renderNoSizes(card); return; }

    if (map.__NO_WIDTH__) {
      const ordered = sortSizes(map.__NO_WIDTH__);
      variants.innerHTML = `<div class="card-product__sizes" aria-label="Available sizes"><ul class="card-product__sizes-list"></ul></div>`;
      const ul = $('.card-product__sizes-list', variants);
      ordered.slice(0, showSizeLimit).forEach(s => {
        const li = document.createElement('li'); li.textContent = s;
        li.setAttribute('data-size', s); li.setAttribute('data-key', s); li.className = 'card-size-chip'; ul.appendChild(li);
      });
      if (ordered.length > showSizeLimit) { const li = document.createElement('li'); li.className = 'more'; li.textContent = `+${ordered.length - showSizeLimit}`; ul.appendChild(li); }
      updateAddToCart(card, null, prod);
      return;
    }

    variants.innerHTML = `<div class="card-product__widths"></div>`;
    const host = $('.card-product__widths', variants);
    const widths = Object.keys(map);

    widths.slice(0, showWidthLimit).forEach(w => {
      const sizes = sortSizes(map[w] || []);
      if (!sizes.length) return;
      const wrap = document.createElement('div');
      wrap.className = 'card-product__width';
      wrap.innerHTML = `<span class="card-product__width-badge">${w}</span><ul class="card-product__sizes-list"></ul>`;
      const ul = $('.card-product__sizes-list', wrap);
      sizes.slice(0, showSizeLimit).forEach(s => {
        const li = document.createElement('li');
        li.textContent = s; li.setAttribute('data-size', s); li.setAttribute('data-width', w);
        li.setAttribute('data-key', `${w}||${s}`); li.className = 'card-size-chip';
        ul.appendChild(li);
      });
      if (sizes.length > showSizeLimit) { const more = document.createElement('li'); more.className = 'more'; more.textContent = `+${sizes.length - showSizeLimit}`; ul.appendChild(more); }
      host.appendChild(wrap);
    });

    if (widths.length > showWidthLimit) {
      const moreW = document.createElement('div');
      moreW.className = 'card-product__width card-product__width--more';
      moreW.innerHTML = `<span class="card-product__width-badge">+${widths.length - showWidthLimit}</span>`;
      host.appendChild(moreW);
    }
    updateAddToCart(card, null, prod);
  }

  // ---------- cart ----------
  async function addVariantToCart(variantId, qty = 1, properties = null) {
    const body = { id: variantId, quantity: qty };
    if (properties && typeof properties === 'object') body.properties = properties;
    const res = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body), credentials: 'same-origin'
    });
    if (!res.ok) throw new Error(`Add failed: ${res.status}`);
    return res.json();
  }
  async function openCartDrawerSafely() {
    if (typeof window.closeAllDrawers === 'function') {
      window.closeAllDrawers(() => {
        try { typeof window.updateCartDrawer === 'function' && window.updateCartDrawer(); } catch {}
        try { typeof window.openCartDrawer   === 'function' && window.openCartDrawer(); } catch {}
      });
      return;
    }
    if (typeof window.openCartDrawer === 'function') {
      try { typeof window.updateCartDrawer === 'function' && window.updateCartDrawer(); } catch {}
      try { window.openCartDrawer(); } catch {}
      return;
    }
    try { document.dispatchEvent(new CustomEvent('cart:open')); document.dispatchEvent(new CustomEvent('drawer:open', { detail: { drawer: 'cart' } })); } catch {}
    const triggers = ['[data-open-cart-drawer]','[data-action="open-drawer"][data-drawer="cart"]','[data-drawer-trigger="cart"]','[aria-controls*="CartDrawer"]','.js-open-cart-drawer','.menu-tools__item--cart a','.header__icon--cart, .icon-cart, #cart-icon-bubble'];
    for (const sel of triggers) { const el = document.querySelector(sel); if (el) { el.click(); return; } }
  }

  // ---------- restricted UI ----------
  function renderInStoreOnly(card) {
    $$('.in-store-only-msg', card).forEach(el => el.remove());
    const { variants } = ensureHosts(card);
    if (variants) variants.style.display = '';
    const add = $('.card-product__add', card); if (add) add.remove();
    const footer = $('.card-product__footer', card);
    const msg = document.createElement('div'); msg.className = 'in-store-only-msg'; msg.setAttribute('role','status'); msg.textContent = 'In-Store Purchase Only';
    if (footer) { if (variants && footer.contains(variants)) variants.insertAdjacentElement('afterend', msg); else footer.appendChild(msg); }
    else { (variants || $('.card-product__price', card) || card).insertAdjacentElement('afterend', msg); }
    log('restricted: UI applied'); scheduleSwatchSync();
  }
  function clearRestrictedState(card) {
    $$('.in-store-only-msg', card).forEach(el => el.remove());
    const variants = $('.card-product__variants', card); if (variants) variants.style.display = '';
    card.__restrictedApplied = false;
  }

  // ---------- row spacer sync ----------
  function hasVisibleSwatches(card) {
    const grp = card.querySelector('.card-product__group .color-group');
    if (!grp) return false;
    const total = grp.querySelectorAll('.group-product').length;
    return total > 1 && getComputedStyle(grp).display !== 'none';
  }
  function groupCardsByRow(cards) {
    const rows = [], tol = 2;
    const sorted = cards.slice().sort((a, b) => a.offsetTop - b.offsetTop);
    for (const card of sorted) {
      const top = card.offsetTop;
      const row = rows.find(r => Math.abs(r.top - top) <= tol);
      if (row) row.items.push(card); else rows.push({ top, items: [card] });
    }
    return rows;
  }
  function syncSwatchRowHeights(root = document) {
    const cards = $$('.card-product', root);
    if (!cards.length) return;
    const rows = groupCardsByRow(cards);
    rows.forEach(({ items }) => {
      const any = items.some(hasVisibleSwatches);
      items.forEach(c => { if (any) c.classList.remove('no-swatch-row'); else c.classList.add('no-swatch-row'); });
    });
  }
  let rafId = 0;
  function scheduleSwatchSync() { if (rafId) cancelAnimationFrame(rafId); rafId = requestAnimationFrame(() => { rafId = 0; syncSwatchRowHeights(); }); }

  // ---------- non-sized detection ----------
  function isNonSizedProduct(prod, map, sizeIdx, widthIdx) {
    if (!map) return false;
    const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, '');
    const isSizePlaceholder  = (s) => ['one','onesize','os','o/s','ns'].includes(norm(s));
    const isWidthPlaceholder = (w) => { const n = norm(w); return n === 'size' || n === '' || n === 'one' || n === 'ns' || n === 'n' || /^[0-9]*n$/.test(n); };

    if (map.__NO_WIDTH__) {
      const sizes = map.__NO_WIDTH__;
      return sizes.length > 0 && sizes.every(isSizePlaceholder);
    }
    const widths = Object.keys(map);
    if (!widths.length) return false;
    const allW = widths.every(isWidthPlaceholder);
    const allS = widths.every(w => { const sizes = map[w] || []; return sizes.length > 0 && sizes.every(isSizePlaceholder); });
    return allW && allS;
  }

  // ---------- fetch + render ----------
  async function fetchAndRender(card, handle, opts) {
    const { initial } = opts || {};
    try {
      if (initial) renderNoSizes(card, 'Checking availability…');
      log('fetchAndRender', { handle, initial });

      const prod = await getProductJson(handle);
      card.__product = prod;

      const { map, sizeIdx, widthIdx } = buildWidthSizeMap(prod);
      card.__variantIndex = buildVariantIndex(prod, sizeIdx, widthIdx);

      if (map && isNonSizedProduct(prod, map, sizeIdx, widthIdx)) {
        const vlist = (prod.variants || []);
        const chosen = vlist.find(v => v.available) || vlist[0];
        hideSizesUI(card);
        updateAddToCart(card, chosen ? { id: chosen.id, available: !!chosen.available, price: chosen.price } : null, prod);
        scheduleSwatchSync();
        return;
      }

      const limits = { showWidthLimit: 5, showSizeLimit: 20 };
      if (map && Object.keys(map).length) { showSizesUI(card); renderMap(card, map, limits, prod); }
      else { renderNoSizes(card, 'No sizes in stock for this color'); }

      scheduleSwatchSync();
    } catch (e) {
      log('error', e);
      if (initial) renderNoSizes(card, 'Unavailable');
      scheduleSwatchSync();
    }
  }

  // ---------- interactions ----------
  function handleChipClick(e, card) {
    const chip = e.target.closest('.card-size-chip');
    if (!chip) return;
    $$('.card-size-chip.is-selected', card).forEach(el => el.classList.remove('is-selected'));
    chip.classList.add('is-selected');
    const key = chip.getAttribute('data-key');
    const v = (card.__variantIndex || {})[key];
    log('chip:selected', key, v);
    updateAddToCart(card, v, card.__product);
  }

  async function handleAddClick(e, card) {
    const btn = e.target.closest('.card-product__add-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const root = btn.closest('.card-product__add');
    const input = root && $('[data-variant-id]', root);
    const vid = input && input.value;
    if (!vid) return;
    try {
      btn.disabled = true; btn.dataset.loading = '1';
      log('ATC:adding', vid);
      await addVariantToCart(Number(vid), 1);
      await openCartDrawerSafely();
      log('ATC:done');
    } catch (err) {
      log('add failed', err);
    } finally {
      btn.dataset.loading = '0'; btn.disabled = false;
    }
  }

  // ---------- boot ----------
  function initCard(card) {
    if (card.dataset.variantsInit === '1') return;
    card.dataset.variantsInit = '1';
    log('initCard', card.getAttribute('data-handle') || '(from link)');

    const handle =
      card.getAttribute('data-handle') ||
      handleFromUrl(($('.card-product__media a', card) || $('.card-product__title a', card) || {}).href || '');

    if (handle) fetchAndRender(card, handle, { initial: true });

    // swatch (color) buttons under media
    card.querySelectorAll('.color-group .group-product button').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = btn.getAttribute('data-url');
        const h = handleFromUrl(url);
        logEv('swatch:click', e);
        if (!h) return;

        // immediate hero swap to avoid lazy-loader revert
        const imgUrl = btn.getAttribute('data-image');
        const hero = card.querySelector('.card-product__media img');
        if (imgUrl && hero) {
          hero.src = imgUrl;
          hero.removeAttribute('data-src');
          hero.classList.remove('preload');
          log('hero:swap', imgUrl);
        }

        // --- NEW: swap price from hidden cache keyed by handle ---
        const priceRow = card.querySelector('.card-product__price-row');
        const priceCache = card.querySelector('.card-product__price-cache');
        if (priceRow && priceCache) {
          const source = priceCache.querySelector(`[data-price-handle="${h}"]`);
          if (source) {
            priceRow.innerHTML = source.innerHTML;
            log('price:swap:handle', h);
          } else {
            log('price:cache-miss', h);
          }
        }

        // sizes + ATC are still driven by product JSON
        fetchAndRender(card, h, { initial: false });

        // Auto-expand the size selector after swatch click
        const toggle = card.querySelector('.card-product__sizes-toggle-input');
        if (toggle && !toggle.checked) toggle.checked = true;
      }, { passive: false });
    });

    initSwatchSlider(card);

    // delegate chips + add; ignore nav or empty rail clicks
    card.addEventListener('click', (e) => {
      if (e.target.closest('[data-nav-guard]')) { logEv('card:ignore:nav', e); return; }
      if (e.target.closest('.card-product__swatch-track') && !e.target.closest('.group-product button')) { logEv('card:ignore:track-empty', e); return; }
      handleChipClick(e, card);
      handleAddClick(e, card);
    });
  }

  const ready = (fn) => { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };
  ready(() => {
    document.querySelectorAll('.card-product:not([data-variants="off"])').forEach(initCard);
    scheduleSwatchSync();
  });
  window.addEventListener('load', scheduleSwatchSync);
  window.addEventListener('resize', scheduleSwatchSync);

  // expose + observe
  window.initCardProductVariants = initCard;
  try {
    const mo = new MutationObserver((muts) => {
      let needsSync = false;
      muts.forEach(m => {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(n => {
            if (!(n instanceof HTMLElement)) return;
            if (n.matches && n.matches('.card-product:not([data-variants="off"])')) { initCard(n); needsSync = true; }
            n.querySelectorAll && n.querySelectorAll('.card-product:not([data-variants="off"])')
              .forEach(el => { initCard(el); needsSync = true; });
          });
        }
      });
      if (needsSync) scheduleSwatchSync();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch {}
})();
